module.exports = __webpack_public_path__ + "assets/Pflegeprodukte.e713b836.png";